function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { createIdentity, createProof, saveCredentials, checkStateContractSync, getCredentials, checkCredentialExistence, removeCredentials, exportIdentity, getIdentity } from "./methods";
export class MetamaskSnap {
    constructor(snapId){
        _define_property(this, "snapId", void 0);
        var _this = this;
        _define_property(this, "getConnector", /*#__PURE__*/ _async_to_generator(function*() {
            return {
                createIdentity: createIdentity.bind(_this),
                saveCredentials: saveCredentials.bind(_this),
                removeCredentials: removeCredentials.bind(_this),
                createProof: createProof.bind(_this),
                checkStateContractSync: checkStateContractSync.bind(_this),
                getCredentials: getCredentials.bind(_this),
                checkCredentialExistence: checkCredentialExistence.bind(_this),
                exportIdentity: exportIdentity.bind(_this),
                getIdentity: getIdentity.bind(_this)
            };
        }));
        this.snapId = snapId;
    }
}

//# sourceMappingURL=snap.js.map